module.exports = __webpack_public_path__ + "static/media/ic-callkit-video-off.f65554ad.webp";